import React from "react";
import Sidebar from "../ui/Sidebar";
import ChooseProduct from "../features/generate/choose-product/ChooseProductPresenter";
import { Route, Routes } from "react-router-dom";
import ProjectHistory from "../features/project-history/ProjectHistoryPresenter";
import GeneratePicture from "../features/generate/generate-picture/GeneratePicturePresenter";

const GeneratePage = () => {
  return (
    <div className="bg-generate-page flex overflow-hidden">
      {/* Sidebar */}
      <Sidebar></Sidebar>
      {/* Content */}
      <div className="h-screen flex-1">
        <Routes>
          <Route path="model" element={<ChooseProduct />} />
          <Route path="model/:selectedProductName" element={<GeneratePicture />} />
          <Route path="photos" element={<ProjectHistory />} />
        </Routes>
      </div>
    </div>
  );
};

export default GeneratePage;
